import CryptoJS from 'crypto-js';

// export function gerarChaveDinamica(bits = 256) {
//     const byteLength = bits / 8; 
//     const array = new Uint8Array(byteLength);
//     window.crypto.getRandomValues(array);

 
//     return Array.from(array).map(b => b.toString(16).padStart(2, '0')).join('');
// }

// const ENCRYPT_KEY = gerarChaveDinamica();

const ENCRYPT_KEY = '5SjvpuNYc12tISt3g0pcOMdKUx7no9'

export async function encryptCryptoJs(payload) {
    
    const valorCriptografado = CryptoJS.AES.encrypt(payload, ENCRYPT_KEY).toString();
    
    return valorCriptografado;
}

export async function decryptCryptoJs(payload) {

    const bytesDescriptografados = CryptoJS.AES.decrypt(payload, ENCRYPT_KEY);
    const valorDescriptografado = bytesDescriptografados.toString(CryptoJS.enc.Utf8);


    return valorDescriptografado;
}
